module.exports = __webpack_public_path__ + "static/img/robot.0f760639.gif";